/**
 * Device heuristics.
 *
 * isMobileDevice answers "is this a phone or tablet?" for deciding whether
 * mobile-oriented nudges (PWA install, device push) are worth screen space.
 * Deliberately NOT a viewport-width check: a narrow desktop window is still a
 * desktop, and an iPad Pro in landscape is wider than many laptops — width
 * classifies the window, these signals classify the device.
 */
export function isMobileDevice(): boolean {
  // Android phones/tablets and iOS devices identify themselves directly.
  if (/android|iphone|ipad|ipod/i.test(navigator.userAgent)) return true;
  // iPadOS 13+ reports a macOS user agent; multi-touch gives it away.
  if (/macintosh|mac os/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1) return true;
  // Fallback: touch-primary with no hover is a phone-shaped device even if
  // the user agent said nothing recognizable.
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}
